var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('forms',{ref:"formList",attrs:{"list":_vm.formList,"value":_vm.formData,"rules":_vm.formRules,"btns":_vm.formBtns,"labelWidth":"120px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }